type TelemetryFunction = () => {
    [key: string]: string | number | object;
};

export abstract class RelodeErrorBase extends Error {
    constructor(message: string) {
        super(message);
    }
    origin: string;
    handler: string;
    abstract getTelemetryData: TelemetryFunction;
}
